import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function OceaneerLab() {
  const dateTexts = ['1898年', '7月', '30日'];
  const title = '調査船オーシャニアラボ 処女航海';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/DisneyMagicTransatlanticDayFiveAtSea25.jpg'
  const description = (
    <>
      <a href='/mary-oceaneer'>
        {'メアリー・オーシャニア船長'}
      </a>
      {'の調査船「'}
      <a href='/oceaneer-lab-disney-magic'>
        {'オーシャニア・ラボ'}
      </a>
      {'」が処女航海に出発する。彼女はこの船で世界中の海を航海し、トレジャーハンターとして各所で美術品・財宝を集める。'}
    </>
  );
  const quoteDomain = 'disneycruiselineblog.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default OceaneerLab;
